import * as React from "react";
import { Icon } from "sb-resp-ui";

export class Name extends React.Component<{ title: string, hasLiveStream?: boolean }, {}> {
    render() {
        return (
            <div className="rj-racing-next-races__game">
                <span className="rj-racing-next-races__game-title">{this.props.title}</span>
                {this.props.hasLiveStream && (<Icon i="i-24-16 i-o-ev-alt-streaming" />)}
            </div>
        )
    }
}